import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import ApiEnter from "@/api/ApiEnter";
import sweetalert from "sweetalert";
import DataRegions from "@/data/AdminPanel/DataRegions";
import ApiRegion from "@/api/ApiRegion";
let RegionEdit = class RegionEdit extends Vue {
    constructor() {
        super(...arguments);
        this.HasLoading = false;
        this.HasGuessingCords = false;
        this.Breadcrumbs = DataRegions.RegionEditBreadcrumbs;
        this.newRegion = { is_active: 1 };
        this.facilitiesList = [];
    }
    async GetAllFacilities() {
        try {
            this.facilitiesList = await ApiRegion.GetEMSFacilities(ApiEnter.CurrentSessionUUID);
        }
        catch (e) {
            this.facilitiesList = [];
        }
    }
    async GuessCoordinates() {
        this.HasGuessingCords = true;
        try {
            if (!this.newRegion.name) {
                this.HasGuessingCords = false;
                return;
            }
            const response = await ApiRegion.GuessCoordinates(ApiEnter.CurrentSessionUUID, this.newRegion.name);
            this.newRegion.iso_code = response.iso_code;
            this.newRegion.longitude = parseFloat(response.longitude);
            this.newRegion.latitude = parseFloat(response.latitude);
        }
        catch (e) {
            this.HasGuessingCords = false;
            return;
        }
        this.HasGuessingCords = false;
    }
    get CanSubmit() {
        const { facility_id, name, region_name, order, delivery, cdek_point, iso_code, latitude, longitude } = this.newRegion;
        const isCdekPointValid = cdek_point && cdek_point.trim() !== '';
        return !!(facility_id && name && region_name && order && delivery && cdek_point && iso_code && latitude && longitude);
    }
    async GetCurrentRegion() {
        try {
            this.newRegion = await ApiRegion.GetRegionByUUID(this.CurrentRegionUUID);
            this.newRegion.order = `${this.newRegion.order}`;
        }
        catch (e) {
            this.newRegion = {};
        }
    }
    async OnClickSubmit() {
        this.HasLoading = true;
        if (ApiEnter.CurrentSessionUUID != undefined) {
            this.$forceUpdate();
            const data = { ...this.newRegion };
            data.order = parseInt(data.order);
            data.mnp_enabled = Number(data.mnp_enabled);
            const success = await ApiRegion.UpdateRegion(ApiEnter.CurrentSessionUUID, this.CurrentRegionUUID, data);
            if (!success) {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
                return;
            }
            sweetalert({
                title: this.$t("general.success"),
                text: this.$t("general.success_created"),
                icon: "success",
            }).then(() => {
                this.$forceUpdate();
                this.$router.push(`/secure/regions`);
            });
        }
        this.HasLoading = false;
    }
    created() {
        this.CurrentRegionUUID = this.$route.params.region_uuid;
        this.GetAllFacilities();
        this.GetCurrentRegion();
    }
};
RegionEdit = __decorate([
    Component({
        components: { StandartTemplate, PageHeader },
    })
], RegionEdit);
export default RegionEdit;
